import React from 'react';
import { Paper } from '@mui/material';

export type NavListCardProps = {
  children: React.ReactNode;
  onClick?: () => void;
};

const NavListCard: React.FC<NavListCardProps> = ({ children, onClick }) => {
  return (
    <Paper
      variant="outlined"
      onClick={onClick}
      sx={{
        p: 1,
        cursor: onClick ? 'pointer' : 'default',
        ...(onClick && {
          '&:hover': {
            bgcolor: 'action.hover',
            borderColor: 'primary.main',
          },
        }),
      }}
    >
      {children}
    </Paper>
  );
};

export default NavListCard;
